__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "cil-template-v1";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.14.0", () => (Promise.all([__webpack_require__.e(390), __webpack_require__.e(995), __webpack_require__.e(524), __webpack_require__.e(490), __webpack_require__.e(674)]).then(() => (() => (__webpack_require__(71390))))));
			register("@aws-sdk/client-s3", "3.6.1", () => (Promise.all([__webpack_require__.e(591), __webpack_require__.e(561)]).then(() => (() => (__webpack_require__(47561))))));
			register("@popperjs/core", "2.11.8", () => (__webpack_require__.e(170).then(() => (() => (__webpack_require__(1170))))));
			register("axios", "0.24.0", () => (__webpack_require__.e(505).then(() => (() => (__webpack_require__(72505))))));
			register("axios", "0.26.0", () => (__webpack_require__.e(191).then(() => (() => (__webpack_require__(36191))))));
			register("axios", "0.26.0", () => (__webpack_require__.e(963).then(() => (() => (__webpack_require__(4963))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(524), __webpack_require__.e(516)]).then(() => (() => (__webpack_require__(2135))))));
			register("graphql", "15.8.0", () => (__webpack_require__.e(172).then(() => (() => (__webpack_require__(8172))))));
			register("graphql", "15.8.0", () => (__webpack_require__.e(113).then(() => (() => (__webpack_require__(113))))));
			register("graphql", "16.12.0", () => (__webpack_require__.e(784).then(() => (() => (__webpack_require__(72784))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(765).then(() => (() => (__webpack_require__(6765))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-helmet-async", "1.3.0", () => (Promise.all([__webpack_require__.e(545), __webpack_require__.e(995), __webpack_require__.e(444)]).then(() => (() => (__webpack_require__(80545))))));
			register("react-player", "2.16.1", () => (Promise.all([__webpack_require__.e(554), __webpack_require__.e(995), __webpack_require__.e(444)]).then(() => (() => (__webpack_require__(13554))))));
			register("react", "17.0.2", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};